import { render, staticRenderFns } from "./SearchService.vue?vue&type=template&id=60020960"
import script from "./SearchService.vue?vue&type=script&lang=ts"
export * from "./SearchService.vue?vue&type=script&lang=ts"
import style0 from "./SearchService.vue?vue&type=style&index=0&id=60020960&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports